import { createConfirmation } from "react-confirm";
import DetailCookTableDialog from "./DetailCookTableDialog";

export const showDetailCookTableDialog = createConfirmation(DetailCookTableDialog);
